module.exports = __webpack_public_path__ + "static/img/store-img.85e51d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/store-img.png
// module id = Ufz0
// module chunks = 1